import { t } from "./index739.mjs";
import { c as o } from "./index766.mjs";
var r = t, a = o, S = r ? {}.toString : function() {
  return "[object " + a(this) + "]";
};
export {
  S as o
};
